import React, { Component } from 'react'

import { withRouter } from 'router/index'

import Form from 'components/Form'
import Link from 'components/Link'
import FormGroup from 'components/FormGroup'
import FormErrors from 'components/FormErrors'
import Input from 'components/Input'
import Button from 'components/Button'
import AuthBox from 'components/AuthBox'
import AuthHeader from 'components/AuthHeader'
import AuthTitle from 'components/AuthTitle'
import AuthLinks from 'components/AuthLinks'

class SignupForm extends Component {
  componentDidMount() {
    this.email.focus()
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.onSubmit()
  }

  render() {
    const {
      emailValue,
      emailErrors,
      onEmailChange,

      passwordValue,
      passwordErrors,
      onPasswordChange,

      generalErrors,

      isLoading
    } = this.props

    return (
      <AuthBox>
        <AuthHeader>
          <AuthTitle>Create an account</AuthTitle>
        </AuthHeader>

        <Form onSubmit={this.handleSubmit} data-selector="auth-signup">
          <FormGroup>
            <Input
              type="text"
              name="email"
              value={emailValue}
              onChange={e => onEmailChange(e.target.value)}
              placeholder="Email"
              ref={(node) => { this.email = node }}
              data-selector="auth-signup-email"
            />

            <FormErrors
              errors={emailErrors}
            />
          </FormGroup>

          <FormGroup>
            <Input
              type="password"
              name="password"
              value={passwordValue}
              onChange={e => onPasswordChange(e.target.value)}
              placeholder="Password"
              data-selector="auth-signup-password"
            />

            <FormErrors
              errors={passwordErrors}
            />
          </FormGroup>

          <FormGroup>
            <Button type="submit" expand loading={isLoading} data-selector="auth-signup-submit">
              Create account
            </Button>

            <FormErrors
              errors={generalErrors}
            />
          </FormGroup>
        </Form>

        <AuthLinks>
          <Link to={this.props.match.url.replace('sign-up', 'login')}>&lsaquo; Login</Link>
        </AuthLinks>
      </AuthBox>
    )
  }
}

export default withRouter(SignupForm)



// WEBPACK FOOTER //
// ./src/components/SignupUI/index.js